export default __webpack_public_path__ + "static/media/notification.6440558b.svg";